import { call, put, takeEvery } from "redux-saga/effects";
import axios from "../../Utils/AxiosConfig/axiosConfig";
import { LOAD_USECASE_BY_PLANTS, LOAD_USECASE_BY_PLANTS_ERROR, LOAD_USECASE_BY_PLANTS_SUCCESS } from "../Types/usecaseByPlants.contsnts";


const getUsecasesByPlants = async () => {
    const response = await axios.get("assets/getPlantsAndUseCases");
    return response.data;
};

function* listUsecasesByPlants():any {
    try {
        const { data } = yield call(getUsecasesByPlants);

        yield put({
            type: LOAD_USECASE_BY_PLANTS_SUCCESS,
            payload: data
        })
    } catch (error) {
        yield put({
              type: LOAD_USECASE_BY_PLANTS_ERROR,
              payload: null,
            });
    }
};

export function* usecasesByPlantsSaga (){
    yield takeEvery(LOAD_USECASE_BY_PLANTS, listUsecasesByPlants);
}


